import axiosInstance from '../../../shared/api/AxiosInstance';
import { fetchAllPagesVia } from '../../../shared/api/paginated';

export function listEvents(params) {
    // FAZ 5 / F5-10 — uc sayfalandi; ekranda sayfalama arayuzu yok, tum
    // sayfalar cekiliyor. Cagiran sozlesmesi (`{ data: [...] }`) DEGISMIYOR.
    return fetchAllPagesVia(axiosInstance, '/events', params ?? {});
}

export function getActiveConnectEvent() {
    return axiosInstance.get('/events/connect-active');
}

export async function getActiveConnectEventQuietly() {
    try {
        const response = await getActiveConnectEvent();
        return response?.data?.data ?? response?.data ?? null;
    } catch {
        return null;
    }
}

export function getEvent(eventId, params) {
    return axiosInstance.get(`/events/${eventId}`, { params });
}

export function getEventStatistics(eventId) {
    return axiosInstance.get(`/events/${eventId}/statistics`);
}

export function listBusinessEvents(businessId) {
    return axiosInstance.get(`/visitor-businesses/businesses/${businessId}/events`);
}

export function listBusinessExhibitorEvents(businessId) {
    return axiosInstance.get(`/businesses/${businessId}/events`);
}

export function joinEvent(eventId, businessId) {
    return axiosInstance.post('/visitor-businesses', { eventId, businessId });
}

export function leaveEvent(eventId, businessId) {
    return axiosInstance.delete(`/visitor-businesses/${eventId}/${businessId}`);
}

export function listEventExhibitors(eventId) {
    return axiosInstance.get(`/events/${eventId}/exhibitors`);
}

export function listAvailableEventExhibitors(eventId) {
    return axiosInstance.get(`/events/${eventId}/exhibitors/available`);
}

export function listExhibitorRegistrations(eventId) {
    return axiosInstance.get('/exhibitor-registrations', { params: { eventId } });
}

export function listPublicExhibitorRegistrations(eventId) {
    return axiosInstance.get('/public/exhibitor-registrations', { params: { eventId } });
}

export function listBusinessUsers(businessId) {
    return axiosInstance.get('/business-users', { params: { businessId } });
}

export function listEventSessions(eventId, params) {
    return axiosInstance.get(`/events/${eventId}/sessions`, { params });
}

export function createSessionReservation(eventId, sessionId, payload) {
    return axiosInstance.post(`/events/${eventId}/sessions/${sessionId}/reservations`, payload);
}

export function listSessionReservations(eventId, sessionId, params) {
    return axiosInstance.get(`/events/${eventId}/sessions/${sessionId}/reservations`, { params });
}

export function deleteSessionReservation(eventId, sessionId, reservationId, config) {
    const normalizedConfig =
        config && (config.params || config.headers || config.data || config.signal)
            ? config
            : config
              ? { params: config }
              : undefined;

    return axiosInstance.delete(
        `/events/${eventId}/sessions/${sessionId}/reservations/${reservationId}`,
        normalizedConfig,
    );
}
